import Typography from "@vapor/react-extended/ExtendedTypography";
import { useDocumentList } from "../../state/useDocumentList";
import Grid from "@vapor/react-material/Grid";

const StatusFilterTableHeader = ({ name }) => {
  const { documentFilterOption } = useDocumentList();

  return (
    <>
      {documentFilterOption !== "CESTINO" && (
        <Grid alignItems="center" display="flex" item sm={6}>
          <Typography variant="body500" color="primary.textTitleColor">
            {name}
          </Typography>
        </Grid>
      )}
    </>
  );
};

export default StatusFilterTableHeader;
